<template>
  <div class="dynamic-form__container">
    <b-form @submit.prevent="onSubmit">
      <b-form-group
        v-for="field in supportedTypesOnly(form.fields)"
        :key="field.key"
        :label="field.name"
        :label-for="field.key"
      >
        <b-form-input
          v-if="isType(field.type, ['text', 'date'])"
          :id="field.key"
          v-model="formData[field.key]"
          :name="field.key"
          :type="field.type"
          autocomplete="off"
        />

        <b-form-textarea
          v-if="isType(field.type, 'multiline_text')"
          :id="field.key"
          v-model="formData[field.key]"
          :name="field.key"
          max-rows="4"
          class="overflow-auto"
          no-resize
        />
      </b-form-group>

      <div class="d-flex justify-content-end border-top pt-3 mt-5">
        <b-button variant="light" type="button" data-test-id="CancelButton" @click.prevent="$emit('cancel')">
          Cancel
        </b-button>

        <b-button variant="danger" type="submit" class="ml-4 font-weight-bold">Save</b-button>
      </div>
    </b-form>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapDataToObject, buildDataFromObject } from "@/App/components/DynamicForm/DynamicFormFunctions";

const SUPPORTED_FIELD_TYPES = ["text", "date", "multiline_text"];

export default Vue.extend({
  name: "DynamicForm",
  props: {
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },

  data(this: any) {
    return {
      formData: mapDataToObject(this.data),
    };
  },

  methods: {
    supportedTypesOnly(fields: Array<any>): Array<any> {
      return fields.filter(({ type }) => SUPPORTED_FIELD_TYPES.includes(type));
    },

    isType(fieldType: string, type: string | Array<string>): boolean {
      return Array.isArray(type) ? type.includes(fieldType) : fieldType === type;
    },

    onSubmit(): void {
      const data = buildDataFromObject(this.formData);

      this.$emit("submit", { data });
    },
  },
});
</script>

<style scoped>
.dynamic-form__container {
  flex: 0 1 auto;
}
button[type="submit"] {
  background-color: red;
  border-color: red;
}
::v-deep label {
  font-weight: bold;
}
</style>
